import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,
    Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const navigate = useNavigate();


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const _calculateTotalQuetzalsAndDollars = async ({refSetFormState, movimiento_monto, movimiento_moneda, movimiento_tipo_cambio}) => {
        switch(movimiento_moneda){
            case 'QUETZAL':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto / movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            case 'DOLAR':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto * movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            default:
                console.log(`No se reconoce la selección: ${movimiento_moneda}`)
            break
        }
    }

    const _calculateLegalizacionPago = async ({setFormState, legalizacion_monto, legalizacion_exoneracion}) => {
        
        setFormState(prevState => ({
            ...prevState,
            legalizacion_pago: parseFloat(legalizacion_monto).toFixed(2) - parseFloat(legalizacion_exoneracion).toFixed(2)
        }))
    }

    const _actionsPostSubmitRequest = async ({isForUpdate, data, identifier, formState, setFormState, }) => {
        const { FormLegalizationPayment } = Forms
        const { fetchManagementLegalizationPayment } = FetchData

        // en caso de que la gestión no requiera más pasos (stepper)
        if ((data.title === 'OK' || data.flag === 'OK') && identifier !== 'ADP') {
            handleClickCloseForm() //vuelve a la pantalla principal
            return
        }
        
        // En el caso de ser insersiones
        if(!isForUpdate){
            // ----------- Ampliación de plazo
            if(identifier === 'ADP') {
                
                setFormState(prevState => ({
                    ...prevState,
                    idgestion: data.rows[0].insertId,
                }))
            }
        }

        // ----------- Ampliación de plazo
        if(identifier === 'ADP') {
            
            // console.log(isForUpdate ? `formState ${formState.idgestion}` : `dataRows ${data.rows[0].insertId}`)
            fetchManagementLegalizationPayment.setParamsToSearch({
                idgestion: isForUpdate ? formState.idgestion : data.rows[0].insertId,
                fecthLegalizationPaymentInfo: {
                    flag: true,
                    refSetFormState: FormLegalizationPayment.setFormState
                }
            })
            fetchManagementLegalizationPayment.executeFetch()
            
        }

        // Siguiente paso
        handleClickNextStep()
        
    }

    const handleClickCloseForm = () => {
        const { FormRequestGlobal } = Forms
        const { onResetForm} = FormRequestGlobal
        onResetForm()
        // navigate si funcionó
        navigate('/juridico/arrendamientos/gestiones')
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleChangeContract = async (event) => {

        const { setShowFormContract } = globalStates
        const { fetchInfoContract } = FetchData
        const { FormRequestGlobal } = Forms
        const { setFormState } = FormRequestGlobal
        
        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [ name ]: value
        }))

        fetchInfoContract.setParamsToSearch({ idcontrato: value })
        fetchInfoContract.executeFetchInfoContract()
        setShowFormContract(true)
    }

    const handleClickCleanUpFiles = (event) => {
        const { FormFiles } = Forms
        const { setFormState } = FormFiles

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        executeFetchAllDeposits()

    }

    const handleClickDeleteDocument = (iddocumento) => {
    
        const { fetchAllFiles } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/common/delete-management-document/${iddocumento}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        fetchAllFiles.executeFetch()
                        // closeModal()
                    }else{
                        
                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleChangeTypeTransaction = async (e) => {

        const { FormLegalizationPayment } = Forms
        const { setFormState, } = FormLegalizationPayment

        const { name, value } = e.target


        setFormState(prevState => ({
            ...prevState,
            // efectivo
            idcaja: '',
            deposito_observaciones: '',
            // deposito
            boleta_numero: '',
            idbanco: '',
            aprobacion_referencia_ach: '',
            aprobacion_check: '',
            aprobacion_observaciones: '',
            acceptedFiles: [],
            fileRejections: [],
            [ name ]: value
        }))
    }

    const handleChangeAmount = (event) => {
        const { FormLegalizationPayment } = Forms
        const { formState, setFormState } = FormLegalizationPayment

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_moneda !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: value,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeTypeCurrency = (event) => {
        const { FormLegalizationPayment } = Forms
        const { formState, setFormState } = FormLegalizationPayment

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: value,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeExchangeRate = (event) => {
        const { FormLegalizationPayment } = Forms
        const { formState, setFormState } = FormLegalizationPayment

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_moneda !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: value
            })
        }

    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }

    }

    const handleChangeLegalizationAmount = (event) => {
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { name, value } = event.target
        if (value < 0) return;
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.legalizacion_exoneracion !== '') {
            _calculateLegalizacionPago({
                setFormState: setFormState,
                legalizacion_monto: value,
                legalizacion_exoneracion: formState.legalizacion_exoneracion
            })
        }

    }

    const handleChangeLegalizationExoneration = (event) => {
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { name, value } = event.target
        if (value < 0) return;
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.legalizacion_monto !== '') {
            _calculateLegalizacionPago({
                setFormState: setFormState,
                legalizacion_monto: formState.legalizacion_monto,
                legalizacion_exoneracion: value
            })
        }

    }

    const handleClickLoadLegalizationPayment = (idgestion) => {

        const { fetchManagementLegalizationPayment } = FetchData
        
        fetchManagementLegalizationPayment.setParamsToSearch({idgestion})
        fetchManagementLegalizationPayment.executeFetch()

        handleClickNextStep()

    }

    const handleClickShowLegalizationTransactionInfo = async (_, title, compont, dataRequest, flagModalOpeningMode) => {

        const { setModalOpeningMode } = globalStates
        const { fetchSpecificLegalizationTransaction } = FetchData
        const { FormLegalizationPayment } = Forms
        const { setFormState } = FormLegalizationPayment

        fetchSpecificLegalizationTransaction.setParamsToSearch({
            idmovimiento: dataRequest.idmovimiento,
            fecthLegalizationPaymentInfo: {
                flag: true,
                refSetFormState: setFormState
            },
        })
        fetchSpecificLegalizationTransaction.executeFetch()

        setModalOpeningMode(flagModalOpeningMode)
        openModal(_, title, compont, dataRequest)

    }

    const handleClickPrintLegalizationTicket = async (idmovimiento) => {

        const { fetchSpecificLegalizationTransaction } = FetchData
        
        fetchSpecificLegalizationTransaction.setParamsToSearch({
            idmovimiento: idmovimiento,
            printTicketFlag: true
        })
        fetchSpecificLegalizationTransaction.executeFetch()

    }

    const handleClickLoadLegalizationFiles = async (idgestion) => {

        const { fetchAllFiles } = FetchData
        
        fetchAllFiles.setParamsToSearch({idgestion})
        fetchAllFiles.executeFetch()

        handleClickNextStep()

    }

    const handleClickNextStepFiles = () => {

        const { fetchAllFiles } = FetchData
        const { FormRequestGlobal } = Forms
        const { stepApplilication, setStepApplilication} = globalStates

        fetchAllFiles.setParamsToSearch({
            idgestion: FormRequestGlobal.formState.idgestion
        })
        fetchAllFiles.executeFetch()
        
        setStepApplilication(stepApplilication+1)
    }

    const onSendLogs = async (e) => {

        
        const { FormRequestGlobal } = Forms
        const {formState, setFormState} = FormRequestGlobal

        const { fetchInfoObservations:{executeFetchAllObservations} } = FetchData


        const {getCurrentDate} = Helpers
        
        // const { fetchAllTypeManagements:{typeManagements} } = FetchData
        
        await marvarApi.post(`/leases/common/log-management/${formState.idgestion}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
        .then(({data}) => {
            alertMessage(data)
            if (data.title === 'OK') {
                setFormState((prevState) => ({
                    ...prevState,
                    aprobacion_observaciones: ''
                }))
                executeFetchAllObservations()
            }
        })

    }

    const onSubmitFormFiles = async (e) => {
    
        // e.preventDefault()
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        
        const { fetchAllFiles } = FetchData
        
        if(formState.acceptedFiles.length === 0){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Debe seleccionar al menos un documento para subir'
            })
            return
        }        

        const _data = new FormData();

        _data.append('idgestion', formState.idgestion);
        _data.append('department', 'JURIDICO');
        _data.append('usuario_creo', user.name);
        _data.append('fecha_creo', new Date());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        // console.log('[useActions][onSubmitFormFiles] formState ', formState )
        // console.log('[useActions][onSubmitFormFiles] _data ', Object.fromEntries(_data.entries()) )

        if(formState.idgestion>0){
            await marvarApi.post(`/leases/common/save-management-documents`, _data )
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles : [],
                            fileRejections : []
                        }))
                        fetchAllFiles.executeFetch()
                    }
                        alertMessage(data)
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }
    }

    const onSubmitFormRequests = async (e) => {
        
        e.preventDefault()
        
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        
        const { 
            identifySelectedRequestType,
            getBodyForDateChange,
            getBodyForDepositRefund,
            getBodyForExtensionOfTerm,
            getGeneralLegalBody
        } = Helpers
        
        const { fetchAllTypeManagements:{typeManagements} } = FetchData
        
        const isForUpdate = (formState.idgestion>0) //Flag para actualizar
        
        let _body
        
        //Validaciones generales
        if(formState.idgestiontipo === 0){
            const messageCustom = {
                message: 'Debe seleccionar una gestion',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return 
        }

        if(formState.idcontrato === 0){
            const messageCustom = {
                message: 'Debe seleccionar un contrato',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return 
        }

        //Switch para validaciones y body personalizados
        const identifier = identifySelectedRequestType(typeManagements, formState.idgestiontipo)
        switch (identifier) {
           
            case 'CFP':{
                _body = await getBodyForDateChange({user, FormRequestGlobal, isForUpdate})
                break;
            }

            case 'DDP':{
                const depositBalance = formState.deposito_total-formState.cargos_extras_total
                
                if(formState.monto_devolucion>depositBalance){
                    const messageCustom = {
                        message: `El monto solicitado superan el deposito total. Saldo de deposito: Q${depositBalance}`,
                        title: 'FAIL',
                        rows: []
                    }
                    alertMessage(messageCustom)    
                    return 
                }
                _body = await getBodyForDepositRefund({user, FormRequestGlobal, isForUpdate})
                break;
            }
            
            case 'ADP': {
                _body = await getBodyForExtensionOfTerm({user, FormRequestGlobal, isForUpdate})
                break;
            }
            
            case 'CJD': // Enviar a cobranza judicial
            case 'FEJ': // Finalización extrajudicial
            case 'FJD': // Finalización judicial
            case 'ECI': { // Envío a cuentas incobrables
                _body = await getGeneralLegalBody({user, FormRequestGlobal, isForUpdate})
                break;
            }

            default:
                console.log('No requiere validaciones adicionales')
            break;
        }

        console.log('[useActions][onSubmitFormRequests] _body ', _body)
        // return

        await marvarApi.post(`/leases/legal/save-management`, _body)
            .then(({data}) => {
                console.log('insert ', data)
                if(data.flag === 'FAIL'){
                    toast.warn(data.message, {
                        position: "top-right",
                        theme: "colored",
                        autoClose: false,
                    })
                    return
                }

                alertMessage(data)
                _actionsPostSubmitRequest({isForUpdate, data, identifier, formState, setFormState})
            })
            .catch(error => {
                console.log('API ERROR: ', error)
                // const { data } = error.response.data
    
                // const resFormatted = {
                //     flag: false,
                //     message: `No fue posible completar la acción, detalles técnicos del error: ${data.message}`
                // }
                // alertMessage(data)
            })
    }

    const onsubmitLegalizationPayment = async () => {

        const { fetchAllFiles } = FetchData

        const { FormLegalizationPayment, FormRequestGlobal } = Forms
        const { formState, setFormState } = FormLegalizationPayment

        if(formState.idmovimiento > 0 && formState.movimiento_tipo === 'EFECTIVO'){
            toast.success(`Verificación de pago: ${formState.idmovimiento} - ${formState.movimiento_tipo}`, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
            fetchAllFiles.setParamsToSearch({
                idgestion: FormRequestGlobal.formState.idgestion
            })
            fetchAllFiles.executeFetch()
            handleClickNextStep()
            return
        }
        
        // Determina si se hace un pago en "efectivo" para confirmar que se incluya información de la caja que recibirá el dinero
        if(formState.movimiento_tipo === 'EFECTIVO' && formState.idcaja === ''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará pago en "efectivo" pero no ha especificado la "caja" que recibe el dinero'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.boleta_numero ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "número de boleta"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.idbanco ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "banco"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado una "foto", o no ha seleccionado una foto valida'
            })
            return;
        }

        
        // Si no paga la totalidad restante no lo deja seguir
        // if(parseFloat(formState.movimiento_quetzales) <= 0 || parseFloat(formState.movimiento_quetzales) > parseFloat(FormRequestGlobal.formState.legalizacion_pago)){
        if(parseFloat(formState.movimiento_quetzales) !== parseFloat(FormRequestGlobal.formState.legalizacion_pago)){
            Swal.fire({
                icon: 'error',
                title: 'Monto invalido',
                text: `No es posible completar el pago porque el monto requerido es de Q${FormRequestGlobal.formState.legalizacion_pago}`
            })
            return;
        }

        const _data = new FormData();
        _data.append('idgestion', FormRequestGlobal.formState.idgestion);
        _data.append('idcaja', formState.idcaja);
        _data.append('idbanco', formState.idbanco);
        _data.append('movimiento_usuario', user.username);
        _data.append('movimiento_fecha', formState.movimiento_fecha);
        _data.append('movimiento_tipo', formState.movimiento_tipo);
        _data.append('movimiento_monto', formState.movimiento_monto);
        _data.append('movimiento_moneda', formState.movimiento_moneda);
        _data.append('movimiento_tipo_cambio', formState.movimiento_tipo_cambio);
        _data.append('movimiento_quetzales', formState.movimiento_quetzales);
        _data.append('movimiento_dolares', formState.movimiento_dolares);
        _data.append('movimiento_observaciones', formState.movimiento_observaciones);
        _data.append('boleta_numero', formState.boleta_numero);
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', new Date() );

        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        // console.log('[useActions][onsubmitLegalizationPayment] _data ', Object.fromEntries(_data.entries()) )

        await marvarApi.post( `/leases/mgmt-management/save-management-legalization-payment`, _data )
            .then(({ data }) => {

                console.log('success------ ', data)
                toast.success(data.msg, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })

                setFormState(prevState => ({
                    ...prevState,
                    idmovimiento: data.data[0]?.insertId || '',
                }))
                // onResetForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)

                toast.warn(`Hubo un problema interno, detalles técnicos: ${error}`, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })
                // onResetForm()
            })
    }

    const onSubmitChangeApprovalStep = async () => {

        const { FormRequestGlobal } = Forms
        const { formState } = FormRequestGlobal
        const { getCurrentDate } = Helpers
        
        const currentDate = getCurrentDate()
        const _body = {
            idgestion: formState.idgestion,
            aprobacion_check: 'Pendiente Aprobacion',
            aprobacion_fecha: currentDate,
            aprobacion_usuario: user.username
        }

        console.log('[useActions][onSubmitChangeApprovalStep] _body ', _body)

        await marvarApi.post( `/leases/common/change-approval-step`, _body )
            .then(({ data }) => {

                console.log('success------ ', data)
                handleClickCloseForm();
                // onResetForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)

                toast.warn(`Hubo un problema interno, detalles técnicos: ${error}`, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })
                // onResetForm()
            })
    }

    return Object.freeze({
        closeModal,
        handleClickCloseForm,
        handleChangeContract,
        handleClickCleanUpFiles,
        handleClickDeleteDocument,
        handleChangeTypeTransaction,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickDownloadImage,
        handleClickReturnStep,
        handleClickNextStep,
        handleChangeLegalizationAmount,
        handleChangeLegalizationExoneration,
        handleClickLoadLegalizationPayment,
        handleClickShowLegalizationTransactionInfo,
        handleClickPrintLegalizationTicket,
        handleClickLoadLegalizationFiles,
        handleClickNextStepFiles,
        onSendLogs,
        onSubmitFormFiles,
        onSubmitFormRequests,
        onsubmitLegalizationPayment,
        onSubmitChangeApprovalStep
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message, flag} = res
        if (title === 'OK' || flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}